import {AfterContentChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Master} from '../../../../admin/models/master.interface';
import {Forms} from '../../../../intelligence-data-entry/models/forms.interface';
import {Questions} from '../../../models/questions.interface';
import {Answer} from '../../../../intelligence-data-entry/models/answer.interface';
import {FormArray, FormBuilder, Validators} from '@angular/forms';
import {FormsService} from '../../../../intelligence-data-entry/services/forms.service';
import {KfRegistrationService} from '../../../../kf-data-entry/services/kf-registration.service';
import {QuestionsService} from '../../../services/questions.service';
import {RoundOfQuestionsService} from '../../../services/round-of-questions.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-edit-forms',
  templateUrl: './edit-forms-admin.component.html',
  styleUrls: ['./edit-forms-admin.component.scss']
})
export class EditFormsAdminComponent implements OnInit, AfterContentChecked {

  country!: boolean;
  name!: string;
  categories!: Master[];
  availableAnswers = [[]];
  categoriesWithQuestions: Master[] = [];
  form!: Forms;
  questions!: Questions[];
  formAnswers!: Answer[];
  sharingLevel = [
    {value: 'UNDISCLOSED', description: 'Undisclosed'},
    {value: 'MEMBERS', description: 'Members'},
    {value: 'PUBLIC', description: 'Public'},
  ];
  reasonUnanswered = [
    {value: 'NO_INFO_AVAILABLE', description: 'No info available'},
    {value: 'LEGAL_GROUNDS', description: 'Legal Grounds'},
    {value: 'COMMERCIAL_SENSITIVITY', description: 'Commercial Sensitivity'},
  ];

  answerForm = this.formBuilder.group({
    answers: this.formBuilder.array([])
  });


  get answerControl(): FormArray {
    return this.answerForm.get('answers') as FormArray;
  }

  constructor(private readonly formsService: FormsService,
              private readonly kfRegistrationService: KfRegistrationService,
              private readonly questionsService: QuestionsService,
              private readonly roundOfQuestionsService: RoundOfQuestionsService,
              private formBuilder: FormBuilder,
              readonly router: Router,
              private readonly route: ActivatedRoute,
              private cd: ChangeDetectorRef) {
    this.country = this.router.url.includes('country'); }

  ngOnInit(): void {
    this.questionsService.getAllQuestionCategories('', {page: 0, size: 100, sort: 'id' , direction: 'asc'}).subscribe(
      data => {
        this.categories = data.content;
        this.route.params.subscribe(
          data2 => {
            this.name = data2.name;
            this.formsService.getFormQuestions(
              Number(data2.roundOfQuestionsId),
              data2.level.charAt(0).toUpperCase() + data2.level.slice(1)).subscribe(
              data3 => {
                this.questions = data3.questions;
                this.categories.forEach(category => {
                  for (const question of this.questions) {
                    if (category.id === question.category.id) {
                      this.categoriesWithQuestions.push(category);
                      break;
                    }
                  }
                });
                this.formsService.getForm(data2.roundOfQuestionsId, this.country, data2.userId).subscribe(
                  data4 => {
                    this.form = data4;
                    this.setArrayForm(data2.userId);
                  }
                );
              }
            );
          }
        );
      }
    );
  }

  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }

  removeRequired(index: number, changeSelector: boolean): void {
    const answerFormat = JSON.parse(this.questions[index].answerFormatString);
    if (this.answerControl.at(index).get('reasonUnanswered')?.value != null) {
      if (changeSelector) {
        this.answerControl.at(index).get('answer')?.setValue(null);
      }
      this.answerControl.at(index).get('answer')?.clearValidators();
      switch (this.questions[index].answerType) {
        case 'NUMBER':
          this.answerControl.at(index).get('answer')?.setValidators([Validators.min(answerFormat.Min), Validators.max(answerFormat.Max)]);
          break;
        case 'TEXT':
          this.answerControl.at(index).get('answer')?.setValidators([Validators.maxLength(answerFormat.MaxLength)]);
          break;
        default:
          break;
      }
    } else {
      switch (this.questions[index].answerType) {
        case 'NUMBER':
          this.answerControl.at(index).get('answer')?.setValidators(
            [Validators.min(answerFormat.Min), Validators.max(answerFormat.Max), Validators.required]);
          break;
        case 'TEXT':
          this.answerControl.at(index).get('answer')?.setValidators([Validators.maxLength(answerFormat.MaxLength), Validators.required]);
          break;
        default:
          this.answerControl.at(index).get('answer')?.setValidators([Validators.required]);
          break;
      }
    }
    this.answerControl.at(index).get('answer')?.updateValueAndValidity();
  }

  goBack(): void {
    this.redirectUrl();
  }

  private setArrayForm(userId: number): void {
    this.availableAnswers.splice(0, this.availableAnswers.length);
    this.questions.forEach((question, index) => {
      const answerFormat = JSON.parse(question.answerFormatString);
      this.answerControl.push(
        this.formBuilder.group({
          id: [{value: null, disabled: true}],
          question: [{value: question, disabled: true}],
          categoryId: [{value: question.category.id, disabled: true}],
          answer: [{value: null, disabled: true}, question.mandatory ? Validators.required : ''],
          sharingLevel: [{value: question.sharingLevel, disabled: true}],
          reasonUnanswered: [{value: null, disabled: true}],
        })
      );

      switch (question.answerType) {
        case 'NUMBER':
          if (question.mandatory) {
            this.answerControl.at(index).get('answer')?.setValidators(
              [Validators.min(answerFormat.Min), Validators.max(answerFormat.Max), Validators.required]
            );
          } else {
            this.answerControl.at(index).get('answer')?.setValidators([Validators.min(answerFormat.Min), Validators.max(answerFormat.Max)]);
          }
          this.answerControl.at(index).updateValueAndValidity();
          this.availableAnswers.push([]);
          break;
        case 'TEXT':
          if (question.mandatory) {
            this.answerControl.at(index).get('answer')?.setValidators([Validators.maxLength(answerFormat.MaxLength), Validators.required]);
          } else {
            this.answerControl.at(index).get('answer')?.setValidators([Validators.maxLength(answerFormat.MaxLength)]);
          }
          this.answerControl.at(index).updateValueAndValidity();
          this.availableAnswers.push([]);
          break;
        case 'LIST':
          this.availableAnswers.push(answerFormat.AvailableAnswers);
          break;
        case 'BOOLEAN':
          this.availableAnswers.push([]);
          break;
      }
    });

    this.formsService.getFormAnswers(
      this.form.id, this.form.year,
      this.country ? userId : undefined,
      !this.country ? userId : undefined).subscribe(
      data => {
        this.formAnswers = data;

        data.forEach(answer => {
          this.answerControl.controls.forEach((control, index) => {
            if (answer.question.id === control.get('question')?.value.id) {
              control.get('id')?.setValue(answer.id);
              control.get('answer')?.setValue(answer.question.multiSelect ? answer.answerString?.split(';') : (answer.question.answerType == 'NUMBER' ? Number(Number(answer.answerString).toFixed(2)): answer.answerString));
              control.get('sharingLevel')?.setValue(answer.sharingLevel);
              control.get('reasonUnanswered')?.setValue(answer.reasonUnanswered);
              if (answer.reasonUnanswered != null) {
                this.removeRequired(index, false);
              }
            }
          });
        });
      }
    );
  }

  private redirectUrl(): void {
    const url: string[] = this.router.url.split('/');
    let navigate = '';
    for (let i = 0; i < url.length - 4; i++) {
      navigate = navigate.concat(url[i] + '/');
    }

    navigate += 'list';
    this.router.navigate([navigate]).then(
      () => {
        // do nothing
      }
    );
  }

}
